import MDInput from "../components/MDInput";

function MyMDInput(props: any) {
  return <MDInput {...props} />;
}

export default MyMDInput;
